import { createSelector } from 'reselect';

const legacyOrderSelectors = (state) => state.legacyOrders;

export const selectLegacyOrders = createSelector(
  legacyOrderSelectors,
  (state) => state.legacyOrders.Data,
);

export const selectLegacyOrdersTotalCount = createSelector(
  legacyOrderSelectors,
  (state) => state.legacyOrders.TotalCount,
);
